module.exports = __webpack_public_path__ + "media/images/lb/291-21ac268956f2511601476ddd6f9e6d1f.svg";